import type { RecommendationOptionsInput } from "../../../configurator";
import {
  HYDRATE_ASSUMPTIONS,
  REVERT_ASSUMPTIONS_DRAFT,
  SAVE_ASSUMPTIONS_SUCCESS,
  UPDATE_ASSUMPTIONS_DRAFT,
} from "../types";

export interface AssumptionsState {
  active: RecommendationOptionsInput | null;
  saved: RecommendationOptionsInput | null;
}

const initialState: AssumptionsState = {
  active: null,
  saved: null,
};

type AssumptionsAction =
  | { type: typeof HYDRATE_ASSUMPTIONS; assumptions: RecommendationOptionsInput }
  | { type: typeof UPDATE_ASSUMPTIONS_DRAFT; assumptions: RecommendationOptionsInput }
  | { type: typeof REVERT_ASSUMPTIONS_DRAFT }
  | { type: typeof SAVE_ASSUMPTIONS_SUCCESS; assumptions: RecommendationOptionsInput };

const assumptionsReducer = (state = initialState, action: AssumptionsAction): AssumptionsState => {
  switch (action.type) {
    case HYDRATE_ASSUMPTIONS:
      return { active: action.assumptions, saved: action.assumptions };
    case UPDATE_ASSUMPTIONS_DRAFT:
      return { ...state, active: action.assumptions };
    case REVERT_ASSUMPTIONS_DRAFT:
      return state.saved != null ? { ...state, active: state.saved } : state;
    case SAVE_ASSUMPTIONS_SUCCESS:
      return { active: action.assumptions, saved: action.assumptions };
    default:
      return state;
  }
};

export default assumptionsReducer;
